export default __webpack_public_path__ + "static/media/appGallery_badge.b3f5f91c.png";